import { createSelector } from 'reselect'

const getTooltips = state => state.user.extra ? state.user.extra.tooltips : ''

const myLibraryFolderSelector = createSelector(
	[getTooltips],
	tooltips => ({
		hasVisitedSubplans: tooltips.tooltipSubsOnboarding === 0,
	})
)

export default myLibraryFolderSelector
